<template>
	<article class="article-container">
		<div
			v-if="$route.name === 'my-stories-shared'
			&& $store.getters.getPromoteOption('promotedProjects').map(promotion => promotion.project.id).includes(project.id)"
			:class="['promoted', {'small-font' : $i18n.locale !== 'EN' && $i18n.locale !== 'JA'}]"
			@click="openProject($event)"
		>
			{{isActivelyPromoted ? $t('projectPage.featured') : $t('projectPage.selected')}}
		</div>
		<div
			:class="[
			'card',
			{'list-mode' : ((isTabletDevice && !$route.name.includes('search') && !$route.name.includes('shared')) || $route.query.view === 'LIST' || forceList) && !forceGrid},
			{'not-published' : project.currentProjectStep !== 'PUBLISHED' && (project.currentProjectStep !== 'RO_APPROVAL') && $route.name !== 'singleCaseWithDates' && $route.name !== 'singleCase'}
		]"
			@click="openProject($event)"
		>
			<button class="save-button button-save" v-if="project.currentProjectStep === 'PUBLISHED' && $route.name !== 'my-stories-shared' && hideSave === false">
				<img
					class="button-save"
					v-if="$store.getters.getSavedProjectIds?.includes(Number(project.id))"
					src="@/common/assets/icons/saved-filled.svg"
					alt="like"
				>
				<img class="button-save" v-else src="@/common/assets/icons/saved.svg" alt="like">
			</button>
			<CardProjectActions :project="project" @hideProject="hideProject" />

			<div class="card-image-container">
				<div class="card-industry" v-if="project.industryReference && project.industryReference.industry">
				<span class="industry">
					{{ project.industryReference.industry.translations.find(translation => translation.language.name === $i18n.locale).name }}
				</span>
					<span class="sub-industry" v-if="project.industryReference.subIndustries?.length > 0">
					{{ project.industryReference.subIndustries[0].translations.find(translation => translation.language.name === $i18n.locale).name }}
				</span>
				</div>
				<img :src="getMainImage()" alt="img" @error="setFallback">
			</div>

			<div class="card-data">
				<div class="card-content-container">
					<h5
						v-if="project.translations?.find(translation => translation.language.name === $i18n.locale)?.referenceTitle"
						v-html="project.translations.find(translation => translation.language.name === $i18n.locale).referenceTitle"></h5>
					<h5 v-else>{{$t('projectPage.noTitle')}}</h5>
					<div class="card-details">
						<div class="detail" v-if="project.management?.datePublish">
							<img :src="require('@/drc/assets/icons/calendar-logo.svg')" alt="calendar">
							<span class="detail-date">
							{{
									`${$i18n.t(`commonDOCX.${new Intl.DateTimeFormat('en-US', {month: 'long'}).format(new Date(project.management.datePublish))}`)}`
								}}
							{{ `${new Date(project.management.datePublish).getDate()}, ${new Date(project.management.datePublish).getFullYear()}` }}
						</span>
						</div>
						<div class="detail">
							<img :src="require('@/drc/assets/icons/eye-logo.svg')" alt="calendar">
							<span class="detail-views">{{ project.views ? `${project.views} ${$t('projectPage.aside.views')}` : `0 ${$t('projectPage.aside.views')}` }}</span>
						</div>
					</div>
				</div>
				<div class="card-language-validations">
					<span class="card-language-text">{{ $t('search.validatedIn') }}</span>
					<div class="language-validation-container">
						<img
							v-for="(language, index) in validatedLanguages" :key="index"
							:src="require(`@/drc/assets/images/flags/${language}.svg`)" alt="flag"
						>
						<div class="language-tooltip" v-if="moreLanguages.length > 0">
							<div class="flags-container" v-for="(language, index) in languages" :key="index">
								<img class="tooltip-flags" :src="require(`@/drc/assets/images/flags/${language}.svg`)" alt="flag-tooltip">
								<p>{{`${LANGUAGE[language.toLowerCase()].name}`}}</p>
							</div>
						</div>
						<span class="language-number" v-if="moreLanguages.length > 0">+{{ `${moreLanguages.length}` }}</span>
					</div>
				</div>

			</div>
		</div>
	</article>

</template>

<script>
import {LANGUAGE, PAGE_NAME} from "@/common/utils/constants";
import buttonMixin from "@/drc/mixins/project-button-mixin";
import * as savedProjectService from "@/drc/services/user.saved.projects.service";
import CardProjectActions from "@/drc/components/CardProjectActions";

export default {
	name: "ProjectCard",
	mixins: [buttonMixin],
	components: {
		CardProjectActions
	},
	props: {
		project: {
			type: Object,
			required: true
		},
		forceList: {
			type: Boolean,
			default: false
		},
		forceGrid: {
			type: Boolean,
			default: false
		},
		hideSave: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			validatedLanguages: [],
			moreLanguages: [],
			languages: [],
			LANGUAGE: LANGUAGE,
		}
	},
	mounted() {
		this.setValidatedLanguages();
	},
	computed: {
		isActivelyPromoted() {
			const promotedProject = this.$store.getters.getPromoteOption('promotedProjects')
				.find(promotion => promotion.project.id === this.project.id && promotion.isActive);

			return promotedProject?.isActive ;
		},
	},
	methods: {
		hideProject(project) {
			this.$emit('hideProject', project);
		},
		openProject(event) {
			if ((this.project.currentProjectStep === 'PUBLISHED' && !event.target.classList.contains('project-actions')) || this.$route.name === PAGE_NAME.singleCSWithDates || this.$route.name === PAGE_NAME.singleCS) {
				if (event.target.classList.contains('button-save')) {
					savedProjectService.toggleSavedProjects(this.project);
				} else {
					const url = this.$router.resolve(this.generateProjectURL()).href;
					window.open(url, "_blank");
				}
			}else if(this.project.currentProjectStep === 'RO_APPROVAL'){
				this.$router.push(this.generateProjectURL() + '?mode=reference-owner-preview');
			}
		},
		generateProjectURL() {
			let dateFormat = new Date(this.project.management.datePublish);

			return `/projects/${dateFormat.getFullYear()}/${dateFormat.getMonth() + 1}/${this.project.id}`;
		},
		setValidatedLanguages() {
			this.validatedLanguages = this.project.translations
				.filter(translation => translation.language.name === "EN" || translation.isValidated === true)
				.map(translation => translation.language.name);

			this.languages = [...this.validatedLanguages]

			if (this.validatedLanguages.length >= 4) {
				this.moreLanguages = this.validatedLanguages.slice((3 - this.validatedLanguages.length));
				this.validatedLanguages = this.validatedLanguages.slice(0, 3);
			}
		},
		getMainImage() {
			const images = this.project.projectImages;
			return images && images.length
				? images.find(image => image.imageType.imageTypeLabel === "main")
					? images.find(image => image.imageType.imageTypeLabel === "main").objectUrl
					: require(`@/drc/assets/images/default-project-image.webp`)
				: require(`@/drc/assets/images/default-project-image.webp`);
		},
		setFallback(event) {
			console.error(`Project with id: ${this.project.id} has problem to load the its main image.`)
			event.target.src = require(`@/drc/assets/images/default-project-image.webp`);
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.article-container {
	position: relative;
	overflow: hidden;

	.promoted {
		position: absolute;
		background: #FFB81C;
		z-index: 1;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		top: 15px;
		left: -69px;
		padding: 5px 15px;
		text-align: center;
		width: 200px;
		font-size: 12px;
		color: black;
		cursor: pointer;
		text-transform: uppercase;

		&.small-font {
			font-size: 11px;
		}
	}

	.card {
		cursor: pointer;
		display: flex;
		flex-direction: column;
		height: 100%;
		clip-path: polygon(0% -6px, 100% -6px, 100% 100%, 100% 100%, 0% 100%);
		position: relative;
		box-shadow: 0 25px 21px -5px #0000001A;

		overflow: hidden;

		&.not-published {
			cursor: unset;
		}

		.save-button {
			position: absolute;
			top: 0;
			right: 24px;
			background: #FFFFFF;
			opacity: 0.5;
			border: 1px solid #E5E5EA;
			width: 44px;
			height: 44px;
			z-index: 3;
			border-radius: 4px;
			cursor: pointer;
			transition: opacity 0.7s ease-in-out;

			img {
				width: 24px;
				height: 24px;
				filter: brightness(0) saturate(100%) invert(35%) sepia(3%) saturate(4785%) hue-rotate(161deg) brightness(83%) contrast(75%);
			}
		}

		.card-image-container {
			height: 45%;
			position: relative;
			z-index: 2;

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 78.76%);
				opacity: 0.5;
				transition: opacity 0.7s ease-in-out;
			}

			.card-industry {
				position: absolute;
				display: flex;
				flex-direction: column;
				gap: 5px;
				bottom: 16px;
				right: 24px;

				.industry {
					padding: 4px 6px;
					background: #001F33;
					color: white;
					font-family: Roboto, sans-serif;
					font-weight: 400;
					font-size: 12px;
					line-height: 11px;
					letter-spacing: 0;
					text-align: right;
				}

				.sub-industry {
					color: white;
					text-align: right;
					font-family: Roboto, sans-serif;
					font-weight: 400;
					font-size: 12px;
					line-height: 11px;
					letter-spacing: 0;
					padding: 4px 6px;
				}
			}

			img {
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
		}

		.card-data {
			background: white;
			display: flex;
			flex-direction: column;
			align-self: flex-end;
			height: 55%;
			width: 100%;
			position: relative;
			overflow: hidden;
			transition: color 0.5s ease-in-out;

			@media (max-width: 320px) {
				justify-content: space-between;
			}

			&::before {
				content: '';
				position: absolute;
				top: 13%;
				left: -13%;
				right: 0;
				bottom: 0;
				z-index: 0;
				background: linear-gradient(90deg, #FFB81C 0%, #FFDF97 100%);
				opacity: 0;
				transform: translate(100%, 100%) rotate(135deg) scale(2);
				transition: transform 0.7s ease-in-out, opacity 0.6s ease-in-out;
			}

			.card-content-container {
				height: 70%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				padding: 24px;

				@media (max-width: 320px) {
					padding: 10px;
					gap: 10px;
					height: auto;
				}

				h5 {
					margin: 0;
					font-family: Roboto, sans-serif;
					font-weight: 500;
					font-size: 17px;
					line-height: 22px;
					letter-spacing: 0;
					text-align: start;
					color: black;
					align-self: flex-start;
					overflow: hidden;
					text-overflow: ellipsis;
					-webkit-line-clamp: 3;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					position: relative;
					z-index: 1;

					@media (max-width: 320px) {
						-webkit-line-clamp: 2;
					}
				}

				.card-details {
					color: black;
					align-self: flex-start;
					display: flex;
					flex-direction: row;
					flex-wrap: nowrap;
					gap: 24px;

					.detail {
						display: flex;
						flex-direction: row;
						flex-wrap: nowrap;
						gap: 5px;

						.detail-views {
							text-align: left;
							position: relative;
							z-index: 1;
						}

						img {
							height: 16px;
							position: relative;
							z-index: 1;
						}

						.detail-date {
							text-align: left;
							position: relative;
							z-index: 1;
						}
					}

					@media (max-width: 320px) {
						flex-wrap: wrap;
						gap: 0;

						.detail {
							width: 100%;

							img {
								width: 16px;
							}
						}
					}
				}
			}

			.card-language-validations {
				height: 30%;
				border-top: 1px solid #3C3C432E;
				color: black;
				padding: 24px;
				align-self: flex-start;
				width: 100%;
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				justify-content: space-between;
				align-items: center;
				position: relative;
				z-index: 1;

				@media (max-width: 320px) {
					padding: 10px;
					flex-wrap: wrap;
					gap: 10px;
				}

				&::before {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					z-index: -1;
					background: linear-gradient(90deg, #FFDF97 0%, #FFB81C 100%);
					opacity: 0;
					transition: opacity 0.5s ease-in;
				}

				.language-validation-container {
					opacity: 0.5;
					min-width: 22px;
					display: flex;
					flex-direction: row;
					justify-content: center;
					flex-wrap: nowrap;

					.language-tooltip {
						position: absolute;
						bottom: 55px;
						right: -25px;
						transform: translateX(-50%);
						background-color: white;
						color: white;
						padding: 6px 10px;
						border-radius: 5px;
						font-size: 14px;
						white-space: nowrap;
						visibility: hidden;
						display: flex;
						flex-direction: column;
						gap: 5px;
						align-items: baseline;

						.flags-container {
							height: 16px;
							border: none;
							margin: 0;
							display: flex;
							flex-wrap: nowrap;

							.tooltip-flags {
								border: none;
								height: 100%;
								width: 100%;
								object-fit: contain;
								margin: 0;
							}

							p {
								margin: 0;
								padding-left: 5px;
								font-weight: 400;
								font-size: 12px;
								text-align: center;
								height: fit-content;
								color: black;
								top: -2px;
								position: relative;
							}
						}
					}

					.language-tooltip::after {
						content: "";
						position: absolute;
						bottom: -11px;
						right: 8px;
						transform: translateX(0) rotate(-180deg);
						width: 0;
						height: 0;
						border-left: 12px solid transparent;
						border-right: 12px solid transparent;
						border-bottom: 16px solid white;
					}

					&:hover {
						opacity: 1;

						.language-tooltip {
							opacity: 1;
							visibility: visible;
						}
					}

					img {
						border: 3px solid white;
						transition: border 0.7s ease;
						border-radius: 50%;
						margin-left: -10px;
						width: 22px;
						height: 22px;
					}

					.language-number {
						border: 3px solid white;
						transition: border 0.7s ease;
						border-radius: 50%;
						background: #FFB81C;
						color: black;
						width: 22px;
						height: 22px;
						margin-left: -10px;
						display: flex;
						align-self: center;
						justify-content: center;
						align-items: center;
						font-family: Roboto, sans-serif;
						font-weight: 600;
						font-size: 10px;
						line-height: 12px;
						letter-spacing: 0.06px;
					}
				}
			}
		}
	}

	.list-mode {
		flex-direction: row;

		.card-data {
			.card-content-container {
				h5 {
					-webkit-line-clamp: 2;
				}
			}
		}

		.save-button {
			z-index: 1;

			@media (max-width: 450px) {
				right: 5px;
			}
		}

		.card-image-container {
			height: 100%;
			width: 35%;
			max-width: 350px;

			@media (max-width: $mobile) {
				width: 42%;
			}

			.card-industry {
				right: 10px;
				gap: 15px;
				bottom: 8px;

				.industry {
					margin-left: 10px;
				}
			}

			img {
				min-height: 166px;
			}
		}

		.card-data {
			height: unset;
			min-width: 65%;
			align-self: unset;

			@media (max-width: $mobile) {
				min-width: 58%;
			}

			.card-content-container {
				height: 100%;
				padding: 30px 75px 6px 12px;

				@media (max-width: $mobile) {
					padding: 24px 51px 6px 10px;
				}
			}

			.card-language-validations {
				padding: 6px 26px 6px 12px;
				height: unset;

				@media (max-width: $mobile) {
					padding: 6px 6px 6px 12px;
				}

				.language-validation-container {
					.language-tooltip {
						z-index: 4;
						bottom: 40px;
					}
				}
			}
		}
	}

	&:hover {
		.card {
			clip-path: polygon(46px -6px, 100% -6px, 100% 100%, 100% 100%, -300px 100%);
			overflow: hidden;

			.save-button {
				opacity: 1;
			}

			.card-image-container {
				&::before {
					opacity: 0.8;
				}
			}

			.card-data::before {
				opacity: 1;
				transform: translate(0, 0) rotate(135deg) scale(3.4);
			}

			.card-language-validations {
				.language-validation-container > .language-number, .language-validation-container > img {
					border: 3px solid #FFB81C;
				}

				.language-validation-container > .language-number {
					background: $notification-background;
					color: #FFB81C;
				}

				&::before {
					opacity: 0.8;
				}
			}
		}

		.list-mode {
			clip-path: polygon(46px -6px, 100% -6px, 100% 100%, 100% 100%, -130px 100%);

			.card-data {
				&::before {
					opacity: 1;
					transform: translate(0, 0) rotate(135deg) scale(9);
				}
			}
		}
	}
}
</style>
